import React from "react";
import CustomSelectWithHookForm from "./custom-select-with-hook-form";
import { Control, FieldErrors, useWatch } from "react-hook-form";
import { useTranslations } from "next-intl";

type TGlobalPageFilterSidebar = {
  control: Control;
  errors: FieldErrors;
};

const GlobalPageSortFields = ({
  control,
  errors,
}: TGlobalPageFilterSidebar) => {
  const t = useTranslations();
  const watchSortField = useWatch({
    control,
    name: "sortField",
  });

  // SORT
  const sortFieldOptions = [
    { value: "newest", label: t("Newest") },
    { value: "oldest", label: t("Oldest") },
    { value: "az", label: "A-Z" },
    { value: "za", label: "Z-A" },
    { value: "none", label: t("None") },
  ];

  const sortOrderOptions = [
    { value: "asc", label: t("Ascending") },
    { value: "desc", label: t("Descending") },
    { value: "none", label: t("None") },
  ];

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium">{t("Sort field:")}</p>
        <CustomSelectWithHookForm
          control={control}
          errors={errors}
          fieldName="sortField"
          options={sortFieldOptions}
        />
      </div>

      {watchSortField !== "oldest" && watchSortField !== "newest" && (
        <div className="flex flex-col gap-1">
          <p className="text-sm font-medium">{t("Sort order:")}</p>
          <CustomSelectWithHookForm
            control={control}
            errors={errors}
            fieldName="sortOrder"
            options={sortOrderOptions}
          />
        </div>
      )}
    </div>
  );
};

export default GlobalPageSortFields;
